import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import './index.css';
import { ConnectedRouter } from 'react-router-redux';
import store, { history } from './redux/store';
import { Route } from 'react-router-dom';
import 'normalize.css/normalize.css';
import 'font-awesome/css/font-awesome.css';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import 'rc-slider/assets/index.css';
import { AuthenticatedRoute } from './containers';
import routes from './routes';
import Layout from './Layouts/MainLayout/MainLayout';
// import config from './config';
//
// if (config.entity === 'mobile-direct') require('./index-md.css');
//
const target = document.querySelector('#root')

render (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Layout>
        {routes.map(route => route.authenticate ? <AuthenticatedRoute {...route} /> : <Route {...route} />)}
      </Layout>
    </ConnectedRouter>
  </Provider>,
  target
);



// WEBPACK FOOTER //
// ./src/index.js